var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select3',{attrs:{"data-url":_vm.column.relation.dataUrl,"multiple":"","value":_vm.value,"value-key":_vm.dataKey},on:{"input":_vm.changed}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22af435a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/metronic/table/header/ColumnRelation.vue
// module id = Exjz
// module chunks = 0 1 2